/* eslint-disable react/no-deprecated */
/// \file App.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.
import React, {Component} from "react";
import "bootstrap/dist/css/bootstrap.css";
import '@progress/kendo-theme-default/dist/all.css';
import "./App.css";
import axios from "axios";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import routes from './routes/routes';
const router = createBrowserRouter(createRoutesFromElements(routes));
//initialize db
console.log("router: ",router);
class App extends Component<any, {apiResponse:string}> {
  constructor(props:any) {
    super(props);
    this.state = { apiResponse: "" };
  }

  callAPI() {
      axios.get("http://localhost:3000/testAPI")
          .then(res => this.setState({ apiResponse: res.data }));
  }

  componentWillMount() {
      this.callAPI();
  }
  render(){
    return(
    <div className="page-container">
      <div className="main-contents">
        <RouterProvider 
        router={router}
        />
      </div>
      <div className="footer" id="footer">
        <hr></hr>
        <h4>CMS <b>Version 1.0.0.0</b></h4>
        <h4>Copyright {'\u00A9'} 2023 LHP Telematics All Rights Reserved.</h4>
        <h4>Questions? Email: {this.state.apiResponse}</h4>
      </div>
    </div>
      );
  }
}

export default App;